import { makeRequest } from 'services/utils';
import { Endpoints } from 'UI/constants/endpoints';

const { BulkEmailSmartTags } = Endpoints;

/**
 * @returns {Promise<OperationResult>}
 */
export const getSmartTags = async () =>
  makeRequest({
    url: BulkEmailSmartTags,
    method: 'get'
  });
